import { z, ZodType } from 'zod';
import { Validation } from '@mews/framework';
import {
    PosMicrosIntegrationAccountingCategory,
    PosMicrosIntegrationAccountingCategoryListItem,
    PosMicrosIntegrationMicrosOutlet,
} from '@mews-commander/data-access';
import { FieldNames } from '../fieldNames';
import { paymentMappingFormSchema } from '../paymentMappings/formProps';

export const accountingCategorySchema = z.object({
    [FieldNames.id]: z.string().default('').catch('').optional(),
    [FieldNames.taxCodes]: z.string().array().default([]).optional(),
}) satisfies ZodType<PosMicrosIntegrationAccountingCategory>;

export const accountingCategoryListItemSchema = z.object({
    [FieldNames.categoryId]: z.string().default('').catch('').optional(),
    [FieldNames.taxCodes]: z.string().array().default([]).optional(),
}) satisfies ZodType<PosMicrosIntegrationAccountingCategoryListItem>;

export const microsOutletFormSchema = z.object({
    [FieldNames.menuNumber]: Validation.String.Required.default(''),
    [FieldNames.name]: Validation.String.Required.default(''),
    [FieldNames.serviceId]: Validation.String.Required.default(''),
    [FieldNames.tipsAccountingCategory]: accountingCategorySchema.optional(),
    [FieldNames.serviceChargeAccountingCategory]: accountingCategorySchema.optional(),
    [FieldNames.discountAccountingCategory]: accountingCategorySchema.optional(),
    [FieldNames.paymentMappings]: paymentMappingFormSchema.array().default([]),
    [FieldNames.netSalesAccountingCategories]: accountingCategoryListItemSchema.array().default([]),
    [FieldNames.outletBillId]: z.string().nullable().default(null),
}) satisfies ZodType<PosMicrosIntegrationMicrosOutlet>;

export type MicrosOutletFormSchema = z.infer<ZodType<PosMicrosIntegrationMicrosOutlet>>;
